module.exports = __webpack_public_path__ + "static/media/nestle.07fee3bd.png";